import { createSlice } from "@reduxjs/toolkit";
import { readFromSessionStorage, saveToSessionStorage } from "utils/helper";

const initialState = {
  data: (() => {
    const storedData = readFromSessionStorage("currentProject");
    return storedData ? storedData : null;
  })(),
  isFetching: false,
  isProjectSet: false,
  error: "",
};

export const currentProject = createSlice({
  name: "currentProject",
  initialState,
  reducers: {
    setProjectBegin: (state) => {
      state.isFetching = true;
      state.error = "";
    },
    setProjectSuccess: (state, action) => {
      state.isFetching = false;
      state.data = action.payload;

      const tempData = {
        ...action.payload,
        logoImage: "",
        displayImage: "",
      };

      saveToSessionStorage("currentProject", tempData);
    },

    setProjectError: (state, action) => {
      state.isFetching = false;
      sessionStorage.removeItem("currentProject");
      state.data = null;
      state.error = action.payload;
    },

    resetState: (state) => {
      return initialState;
    },
  },
});

export const { setProjectBegin, setProjectSuccess, setProjectError } =
  currentProject.actions;

export const currentProjectSelector = (state) => state.currentProject.data;

export default currentProject.reducer;
